import { Component, Input, OnInit } from '@angular/core';
import { HelperService } from '../../../Services/helper.service';
import { LastActions } from '../../../models/lastActions';
import { TranslationService } from '../../../Services/translation.service';

@Component({
  selector: 'app-lastactivities',
  templateUrl: './lastactivities.component.html',
  styleUrls: ['./lastactivities.component.css']
})
export class LastactivitiesComponent implements OnInit {
  @Input() lastActions: LastActions;

  word: any = {};
  language: string = '';

  constructor(
    private helperService: HelperService,
    private translationService: TranslationService
  ) {
    this.word = this.translationService.word;
    this.language = this.translationService.language;
  }

  ngOnInit(): void { }

  toLatin(word: string): string {
    return word = this.helperService.toLatin(word);
  }
}
